// GENERATED FILE — do not edit by hand.
// Regenerate with: node frontend/scripts/darkmode-logos.mjs
// See z_ralph/tasks/1_new_tasks/darkmode/spec-logos-and-badges.md (Task 1).

export type LogoTreatment = 'raw' | 'stripped' | 'tile';

export const logoTreatments: Record<string, LogoTreatment> = {
  '/suppliers/aapnootbrood_logo.png': 'raw',
  '/suppliers/abinbev_logo.png': 'tile',
  '/suppliers/alberthein_logo.png': 'stripped',
  '/suppliers/altinpetek_logo.png': 'tile',
  '/suppliers/altseafood_logo.png': 'raw',
  '/suppliers/andrekerstens_logo.png': 'stripped',
  '/suppliers/antep_logo.png': 'stripped',
  '/suppliers/any_invoice_logo.png': 'raw',
  '/suppliers/aps_logo.png': 'stripped',
  '/suppliers/avo_logo.png': 'stripped',
  '/suppliers/baghrir_logo.png': 'tile',
  '/suppliers/banketbakkerij_logo.png': 'stripped',
  '/suppliers/bartsbottles_logo.png': 'tile',
  '/suppliers/bemakers_logo.png': 'tile',
  '/suppliers/bergfood_logo.png': 'raw',
  '/suppliers/bestbreadboba_logo.png': 'tile',
  '/suppliers/bevenco_logo.png': 'tile',
  '/suppliers/bidfood_logo.jpg': 'stripped',
  '/suppliers/bidfood_logo_nobg.png': 'tile',
  '/suppliers/binsbergen_logo.png': 'tile',
  '/suppliers/bjdelogie_logo.png': 'stripped',
  '/suppliers/bolomey_logo.png': 'stripped',
  '/suppliers/bottlebusiness_logo.png': 'stripped',
  '/suppliers/bourgogneexpress_logo.png': 'tile',
  '/suppliers/brandingclub_logo.png': 'tile',
  '/suppliers/bronwijn_logo.png': 'tile',
  '/suppliers/brouwerijnoordt_logo.png': 'tile',
  '/suppliers/buonappetito_logo.png': 'tile',
  '/suppliers/casaron_logo.png': 'stripped',
  '/suppliers/cavinoir_logo_nobg.png': 'tile',
  '/suppliers/ceesvannoordwijn_logo.png': 'stripped',
  '/suppliers/cellarmasters_logo.png': 'tile',
  '/suppliers/chefsfarm_logo.png': 'tile',
  '/suppliers/chocoseum_logo.png': 'stripped',
  '/suppliers/claudia_logo.png': 'stripped',
  '/suppliers/cocktailunlimited_logo.png': 'stripped',
  '/suppliers/cookboon_logo.png': 'tile',
  '/suppliers/cornybakers_logo.png': 'stripped',
  '/suppliers/damman_logo.png': 'tile',
  '/suppliers/dasbrot_logo.png': 'tile',
  '/suppliers/deambachterie_logo.png': 'tile',
  '/suppliers/debergsecave_logo.png': 'stripped',
  '/suppliers/debruijn_logo.png': 'stripped',
  '/suppliers/degoudenton_logo.png': 'tile',
  '/suppliers/degrootedelgebak_logo.png': 'stripped',
  '/suppliers/deklokdranken_logo.png': 'stripped',
  '/suppliers/dekoekfabriek_logo.png': 'stripped',
  '/suppliers/dekoningvlees_logo.png': 'raw',
  '/suppliers/delicatezzeditalia_logo.png': 'stripped',
  '/suppliers/deweert_logo.png': 'stripped',
  '/suppliers/dorstlust_logo.png': 'tile',
  '/suppliers/drankdozijn_logo.png': 'stripped',
  '/suppliers/drankenhandel_logo.png': 'stripped',
  '/suppliers/driessenfood_logo.png': 'stripped',
  '/suppliers/drinksfromjapan_logo.png': 'raw',
  '/suppliers/dronk_logo_nobg.png': 'tile',
  '/suppliers/drtrading_logo.png': 'tile',
  '/suppliers/dudok_logo.png': 'stripped',
  '/suppliers/dun_yong_logo.png': 'stripped',
  '/suppliers/dutchwasabi_logo.png': 'tile',
  '/suppliers/dvine_logo.png': 'tile',
  '/suppliers/dzw_logo.jpeg': 'raw',
  '/suppliers/ebo_logo.png': 'raw',
  '/suppliers/eneco_logo.png': 'stripped',
  '/suppliers/espresso_sw_logo.png': 'stripped',
  '/suppliers/eurofins_logo.png': 'tile',
  '/suppliers/europastry_logo.png': 'raw',
  '/suppliers/euroslagerijgrieving_logo.png': 'tile',
  '/suppliers/evides_logo.png': 'tile',
  '/suppliers/exclusivelabelbenelux_logo.png': 'stripped',
  '/suppliers/filiuskaas_logo.png': 'stripped',
  '/suppliers/filta_logo.png': 'stripped',
  '/suppliers/fixfisch_logo.png': 'stripped',
  '/suppliers/fontijn_logo.png': 'stripped',
  '/suppliers/foodsteps_logo.png': 'stripped',
  '/suppliers/fourcroy_logo.png': 'tile',
  '/suppliers/freshfood_dh.png': 'stripped',
  '/suppliers/frobel_logo.png': 'tile',
  '/suppliers/fullcircle_logo.png': 'stripped',
  '/suppliers/gebogelato_logo.png': 'stripped',
  '/suppliers/gioempanadas_logo.png': 'stripped',
  '/suppliers/gnb_logo.png': 'tile',
  '/suppliers/gnb_logo_nobg.png': 'tile',
  '/suppliers/goldtdrinks_logo.png': 'raw',
  '/suppliers/grapedistrict_logo.png': 'stripped',
  '/suppliers/greenfreshfood_logo.png': 'stripped',
  '/suppliers/guillaume_logo.png': 'stripped',
  '/suppliers/hanos_logo.png': 'tile',
  '/suppliers/haveafew_logo.png': 'tile',
  '/suppliers/heineken_logo.png': 'tile',
  '/suppliers/hicret_logo.png': 'stripped',
  '/suppliers/hoecksevis_logo.png': 'stripped',
  '/suppliers/hollandvis_logo.png': 'stripped',
  '/suppliers/horecagoedkoop_logo.png': 'stripped',
  '/suppliers/horecaking_logo.png': 'stripped',
  '/suppliers/houseofcaviar_logo.png': 'stripped',
  '/suppliers/hyscon_logo.png': 'stripped',
  '/suppliers/ianenwijn_logo.png': 'raw',
  '/suppliers/ibholland_logo.png': 'tile',
  '/suppliers/icefactory_logo.png': 'tile',
  '/suppliers/ijsenijskoud_logo.png': 'stripped',
  '/suppliers/illy_logo.png': 'raw',
  '/suppliers/ilovecannoli_logo.png': 'raw',
  '/suppliers/interfastfood_logo.png': 'stripped',
  '/suppliers/jansondranken_logo.png': 'tile',
  '/suppliers/janvanas_logo.png': 'stripped',
  '/suppliers/jessedelicatesse_logo.png': 'stripped',
  '/suppliers/jfcholland_logo.png': 'stripped',
  '/suppliers/joka_logo.png': 'tile',
  '/suppliers/jong_vader_logo.png': 'tile',
  '/suppliers/jordysbakery_logo.png': 'tile',
  '/suppliers/josglas_logo.png': 'stripped',
  '/suppliers/jouwgroenteman_logo.png': 'stripped',
  '/suppliers/kaapsebrouwers_logo.png': 'stripped',
  '/suppliers/kaasatelier_logo.png': 'stripped',
  '/suppliers/kaasfort_logo.png': 'stripped',
  '/suppliers/karelvdvorm_logo.png': 'stripped',
  '/suppliers/kemmewines_logo.png': 'stripped',
  '/suppliers/kiya_logo.png': 'raw',
  '/suppliers/kobier_logo.png': 'tile',
  '/suppliers/koekela_logo.png': 'tile',
  '/suppliers/koektails_logo.png': 'stripped',
  '/suppliers/koelmonteur_logo.png': 'tile',
  '/suppliers/koffiekompaan_logo.png': 'stripped',
  '/suppliers/kompaan_logo.png': 'tile',
  '/suppliers/koylu_logo.png': 'stripped',
  '/suppliers/kraan_logo.png': 'stripped',
  '/suppliers/kwastwijnkopers_logo.png': 'stripped',
  '/suppliers/lakarusch_logo.png': 'stripped',
  '/suppliers/lamuse_logo.png': 'tile',
  '/suppliers/laprosciutteria_logo.png': 'tile',
  '/suppliers/lasalute_logo.jpg': 'stripped',
  '/suppliers/lexception_logo.png': 'stripped',
  '/suppliers/lfe_logo.png': 'tile',
  '/suppliers/lindenhoff_logo.png': 'tile',
  '/suppliers/lindschotendrink_logo.png': 'raw',
  '/suppliers/linschoten_logo.png': 'tile',
  '/suppliers/localharvest_logo.png': 'stripped',
  '/suppliers/loui_logo.png': 'stripped',
  '/suppliers/maisonroutin_logo.png': 'raw',
  '/suppliers/manetti_logo.png': 'tile',
  '/suppliers/manmetbrilkoffie_logo.png': 'tile',
  '/suppliers/marckroonwijn_logo.png': 'raw',
  '/suppliers/mariuswijnsake_logo.png': 'tile',
  '/suppliers/minzevenijs_logo.png': 'stripped',
  '/suppliers/moestuinvollenhoven_logo.png': 'stripped',
  '/suppliers/moethennessy_logo.png': 'tile',
  '/suppliers/naturalia_logo.png': 'stripped',
  '/suppliers/nespresso_logo.png': 'raw',
  '/suppliers/nicetomeat_logo.png': 'stripped',
  '/suppliers/nitrobrew_logo.png': 'stripped',
  '/suppliers/noordmanwijnimport_logo.png': 'stripped',
  '/suppliers/notenfabriek_logo.png': 'tile',
  '/suppliers/nrbc_logo.png': 'stripped',
  '/suppliers/ollecobunge_logo.png': 'stripped',
  '/suppliers/otelli_logo.png': 'tile',
  '/suppliers/pastanobile_logo.png': 'tile',
  '/suppliers/patisseriebondsmolders_logo.png': 'tile',
  '/suppliers/peeze_logo.png': 'tile',
  '/suppliers/pieksmanwijn_logo.png': 'tile',
  '/suppliers/profilgrec_logo.png': 'tile',
  '/suppliers/properproducts_logo.png': 'stripped',
  '/suppliers/purematcha_logo.png': 'tile',
  '/suppliers/qculinair_logo.png': 'stripped',
  '/suppliers/qsta_logo.png': 'stripped',
  '/suppliers/quebracho_logo.png': 'stripped',
  '/suppliers/rellmanfoods_logo.png': 'stripped',
  '/suppliers/rightspirits_logo.png': 'raw',
  '/suppliers/rijnmondgas_logo.png': 'stripped',
  '/suppliers/rijpelaal_logo.png': 'stripped',
  '/suppliers/rungis_logo.png': 'tile',
  '/suppliers/ruyken_logo.png': 'stripped',
  '/suppliers/sakebase_logo.png': 'tile',
  '/suppliers/sanderswijnkopers_logo.png': 'stripped',
  '/suppliers/santaskoffie_logo.png': 'stripped',
  '/suppliers/scanwic_logo.png': 'stripped',
  '/suppliers/schmidtzeevis_logo.png': 'tile',
  '/suppliers/seafoodcentre_logo.png': 'stripped',
  '/suppliers/sebcocktails_logo.png': 'tile',
  '/suppliers/senzatea_logo.png': 'raw',
  '/suppliers/sidhu_logo.png': 'stripped',
  '/suppliers/slagerijooteman_logo.png': 'stripped',
  '/suppliers/sligro_logo.png': 'stripped',
  '/suppliers/smitsdelicious_logo.png': 'tile',
  '/suppliers/stadshavenbrouwerij_logo.png': 'tile',
  '/suppliers/staffhorst_logo.png': 'stripped',
  '/suppliers/stationbergweg_logo.png': 'tile',
  '/suppliers/swinkels_logo.png': 'tile',
  '/suppliers/takeaware_logo.png': 'tile',
  '/suppliers/tastetree_logo.png': 'stripped',
  '/suppliers/tonkonijn_logo.png': 'stripped',
  '/suppliers/treuren_logo.png': 'stripped',
  '/suppliers/unsupported/action_logo.png': 'tile',
  '/suppliers/unsupported/alberthein_logo.png': 'stripped',
  '/suppliers/unsupported/google_logo.png': 'stripped',
  '/suppliers/unsupported/horecarama_logo.png': 'tile',
  '/suppliers/unsupported/horecaworld_logo.png': 'stripped',
  '/suppliers/unsupported/lidl_logo.png': 'stripped',
  '/suppliers/unsupported/sidhu_logo.png': 'stripped',
  '/suppliers/unsupported/ziggo_logo.png': 'stripped',
  '/suppliers/upta_logo.png': 'stripped',
  '/suppliers/vandebakker_logo.png': 'stripped',
  '/suppliers/vangelder_logo.png': 'tile',
  '/suppliers/vangelder_logo_nobg.png': 'tile',
  '/suppliers/vanhatten.png': 'tile',
  '/suppliers/vanillaventure_logo.png': 'tile',
  '/suppliers/vanleersum_logo.png': 'raw',
  '/suppliers/vatex_logo.png': 'stripped',
  '/suppliers/verbuntverlinden_logo.png': 'stripped',
  '/suppliers/verhoek_logo.png': 'tile',
  '/suppliers/verisure_logo.png': 'stripped',
  '/suppliers/vetlazy_logo.png': 'stripped',
  '/suppliers/vhcjongens_logo.png': 'raw',
  '/suppliers/vhckreko_logo.png': 'raw',
  '/suppliers/vinites_logo.png': 'stripped',
  '/suppliers/vinvin_logo.png': 'raw',
  '/suppliers/vlaamschbroodhuys_logo.png': 'stripped',
  '/suppliers/vleck_logo.png': 'tile',
  '/suppliers/vulcaanbier_logo.png': 'stripped',
  '/suppliers/westlandpeppers_logo.png': 'stripped',
  '/suppliers/whiskysite_logo.png': 'stripped',
  '/suppliers/wijnhandelherman_logo.png': 'tile',
  '/suppliers/winespirits_logo.png': 'stripped',
  '/suppliers/wintax_logo.png': 'raw',
  '/suppliers/winterhalter_logo.png': 'stripped',
  '/suppliers/yama_logo.png': 'raw',
  '/suppliers/zeechocolate_logo.png': 'stripped',
  '/suppliers/zuiver_logo.png': 'stripped',
};
